<template>
  <el-autocomplete
    ref="suggestion"
    v-model.trim="item.value"
    :fetch-suggestions="handleSearch"
    placeholder="请输入材质"
  ></el-autocomplete>
</template>

<script>
export default {
  name: 'GoodsTexture',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    propertyList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    async handleSearch(str, cb) {
      let pName = ''
      let p = this.propertyList.find(v => v.text === '品名')
      if (p) {
        pName = p.value
      }
      try {
        const { success, data } = await this.$get('essential.getTextureListByPName', {
          essentialInfoDTO: { pName: pName, texture: str }
        })
        if (success && data && data[0] && data[0].textureResultList) {
          let mapList = data[0].textureResultList.map(v => ({ value: v.texture }))
          cb(mapList)
        } else {
          cb([])
        }
      } catch (e) {
        console.log(e)
        cb([])
      }
    }
  }
}
</script>
